import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { RegisterNewCrubs } from 'practice/constants/practice-register-crubs';
import FormRegister, { FormRegisterVM } from 'practice/components/register/form';
import { useNavigate } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';

const NewRegister = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-registro');
  });

  const insertRegister = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/tipo-registro/`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormRegisterVM) => {
      const dataInsert = insertRegister({
        data: {
          descrizioneRegistro: values.description,
          key: {
            tipoRegistro: values.type,
          },
        },
      }) as AxiosPromise;
      dataInsert.then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-registro');
      });
    },
    [insertRegister, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={RegisterNewCrubs} />
      <FormRegister title="Nuovo Registro" onCancel={onCancel} onSubmit={onSubmit} />
    </Fragment>
  );
};

NewRegister.displayName = 'New Register Page component';

export default NewRegister;
